export default __webpack_public_path__ + "static/media/hashTag.d6e646fc.svg";